import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset } from '@opallabs/kuiper'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { DragAndDropAssetGallery } from '../../../../../DragAndDropAssetGallery'
import { threadsStandardPositions } from '../../../../../DragAndDropAssetGallery/positions'
// import { ThreadsSingleFooter } from '../../../sharedDisplays/footers/ThreadsSingleFooter'
import { LinkPreviewAssetCarousel } from '../../../../../LinkPreviewAssetCarousel'
import {
  threadsStandardDesktopFields,
  threadsStandardMobileFields,
} from '../../../../../LinkPreviewAssetCarousel/fields'
import { useContentWithLinkPreviewAssetCarousel } from '../../../../helpers/hooks'
import {
  LinkWithData,
  OnLinkDataUpdate,
  OnShowAssetPickerProps,
} from '../../../../helpers/types'
import { ThreadsSingleHeader } from '../../../sharedDisplays/headers/ThreadsSingleHeader'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  assets: AssetReference[]
  content: string
  display: string
  isPresenting: boolean
  isSnapshot: boolean
  linksWithData: LinkWithData[]
  onAssetChange: () => void
  onContentChange: (val: string) => void
  onExpandAsset: (assetId: number) => void
  onLinkDataUpdate: OnLinkDataUpdate
  onRemoveAsset: (assetId: number) => void
  onShowAssetPicker: (args: OnShowAssetPickerProps) => void
  readOnly: boolean
  updateCaption: () => void
}

export const Single: React.FC<Props> = ({
  accountImage,
  accountName,
  assets,
  content,
  display = 'mobileSingle',
  isPresenting = false,
  linksWithData,
  onAssetChange,
  onContentChange,
  onExpandAsset,
  onLinkDataUpdate,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly,
  updateCaption,
}) => {
  const isMobile = display.includes('mobile')
  const { link, isPersistingLink, setIsPersistingLink, linkWithData } =
    useContentWithLinkPreviewAssetCarousel({
      content,
      linksWithData,
    })
  const linkAssets = linkWithData ? linkWithData.assetReferences : []

  return (
    <Fragment>
      <ThreadsSingleHeader
        accountImage={accountImage}
        accountName={accountName}
        isMobile={isMobile}
      />
      <ContentTextInput
        characterLimit={500}
        placeholder="Add comment..."
        readOnly={readOnly}
        value={content}
        highlightSocialTags={true}
        onChange={onContentChange}
        style={styles.getContentWrapper(isMobile)}
      />
      {assets.length === 0 && isPersistingLink && (
        <div css={styles.contentWrapper}>
          <LinkPreviewAssetCarousel
            assetStyle={styles.getLinkAssetStyle(
              linkAssets.length > 0,
              display
            )}
            disableRemoveLink={false}
            fields={
              isMobile
                ? threadsStandardMobileFields
                : threadsStandardDesktopFields
            }
            descriptionStyle={styles.getLinkDescriptionStyle(isMobile)}
            domainStyle={styles.getLinkDomainStyle(isMobile)}
            hasRemovedLink={() => setIsPersistingLink(false)}
            hasSquareInlineAsset={false}
            link={link}
            linkStyle={styles.getLinkStyle(linkAssets.length > 0, display)}
            linkWithData={linkWithData}
            onLinkDataUpdate={onLinkDataUpdate}
            onShowAssetPicker={onShowAssetPicker}
            readOnly={readOnly || isPresenting}
            titleStyle={styles.linkTitleStyle}
          />
        </div>
      )}
      {assets.length === 1 && (
        <div css={styles.contentWrapper}>
          <Asset
            assetReference={assets[0]}
            hasAssetOptions={true}
            hasAssetOverlay={assets[0] && (!readOnly || isPresenting)}
            imageFit="cover"
            onEmbiggen={(): void => onExpandAsset(assets[0].id || 0)}
            onRemove={(): void => onRemoveAsset(assets[0].id || 0)}
            overrideStyles={styles.getAssetStyles(assets[0], isMobile)}
            placeholder={true}
            removeable={!isPresenting}
            updateCaption={updateCaption}
          />
        </div>
      )}
      {assets.length > 1 && (
        <div css={styles.contentWrapper}>
          <DragAndDropAssetGallery
            assets={assets}
            display={display}
            galleryContainerStyles={styles.getGalleryContainer(display)}
            hasAssetOptions={true}
            isPresenting={isPresenting}
            maxAssets={20}
            maxHeight={isMobile ? 305 : 305}
            maxWidth={isMobile ? 407 : 407}
            onAssetChange={onAssetChange}
            onExpandAsset={onExpandAsset}
            onRemoveAsset={onRemoveAsset}
            positions={threadsStandardPositions}
            readOnly={readOnly}
            updateCaption={updateCaption}
          />
        </div>
      )}
      {/* Bring this back once we have Thread-specific footer icons */}
      {/* <ThreadsSingleFooter isMobile={isMobile} /> */}
    </Fragment>
  )
}
